import { render, staticRenderFns } from "./GroupingByCustomField.vue?vue&type=template&id=44b870d5"
import script from "./GroupingByCustomField.vue?vue&type=script&lang=js"
export * from "./GroupingByCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports